module.exports = __webpack_public_path__ + "static/media/NCASH.89027385.png";